/**
 * Admin project fixtures — kept for local UI demos only.
 * Live admin project detail uses the same member portal APIs
 * (getProjectById, getSessions, getProjectStats, tasks, etc.).
 */
import {
  PROJECTS,
  TASK_GROUPS,
  MY_TASKS,
  COLLABORATORS,
} from "./projectData"
import { PROJECT_ROWS } from "./adminProjectsData"

export const USE_ADMIN_PROJECT_FIXTURES = false

export const ADMIN_MOCK_TASK_STATS = {
  total: 15,
  completed: 8,
  inProgress: 4,
  notStarted: 3,
  hoursLogged: "42 hrs",
}

const STATUS_BY_LISTING = {
  active: "in-progress",
  future: "upcoming",
  completed: "past",
}

const STATUS_LABEL = {
  "in-progress": "In Progress",
  upcoming: "Upcoming",
  past: "Completed",
}

const normalizeStatus = project => {
  const key =
    typeof project.status === "string"
      ? project.status
      : project.status?.status || "in-progress"
  return {
    status: key,
    statusLabel:
      project.statusLabel ||
      project.status?.statusLabel ||
      STATUS_LABEL[key] ||
      "In Progress",
  }
}

const buildMembers = collaborators =>
  (collaborators || []).map((collaborator, index) => ({
    id: String(index + 1),
    userId: String(1000 + index),
    name: collaborator.name,
    avatar: collaborator.avatar,
    role: collaborator.role,
    status: collaborator.status,
    user: {
      id: 1000 + index,
      first_name: collaborator.name?.split(" ")[0] || "",
      last_name: collaborator.name?.split(" ").slice(1).join(" ") || "",
      email: `${collaborator.name?.replace(/\s+/g, ".").toLowerCase() || "member"}@example.com`,
    },
    role_types: [{ public_name: collaborator.role, name: collaborator.role }],
  }))

/** Project detail shape expected by ProjectLayout / overview tabs. */
export const getAdminMockProject = projectId => {
  const row = PROJECT_ROWS.find(item => String(item.id) === String(projectId))
  const statusKey = row ? STATUS_BY_LISTING[row.status] || "in-progress" : null
  const base =
    PROJECTS.find(project => project.status === statusKey) || PROJECTS[0]
  const status = normalizeStatus(base)

  const title = row?.title || base.title
  const category = row?.category || base.category
  const city = row?.city || base.city

  const members = buildMembers(base.collaborators)

  return {
    ...base,
    id: projectId,
    name: title,
    title,
    category,
    categories: category ? [category] : [],
    location: city,
    city,
    startDate: row?.startDate || base.startDate,
    endDate: base.endDate,
    targetDate: base.targetDate || base.endDate,
    status,
    members,
    collaborators: members,
    estimatedHours: base.estimatedHours || [],
    sessions: base.sessions || [],
  }
}

export const getAdminMockTaskGroups = () => TASK_GROUPS

export const getAdminMockMyTasks = () => MY_TASKS

export const getAdminMockCollaborators = () =>
  COLLABORATORS.map((collaborator, index) => ({
    ...collaborator,
    id: index + 1,
    memberId: index + 1,
    status: String(collaborator.status || "pending").toLowerCase(),
  }))
